import IndividualInvestor from './IndividualInvestor';
import { AccountType } from 'further-types/investor';
import LegalEntity from './LegalEntity';
import useVehicleApplication from 'hooks/lp/data/vehicleApplication/useVehicleApplication';

type Props = {
  vehicleId: string;
  isActive: boolean;
  vehicleApplicationId: string;
  onSave: () => void;
};

const CoreInformation: React.FC<Props> = ({
  isActive,
  vehicleId,
  vehicleApplicationId,
  onSave,
}) => {
  const { investor } = useVehicleApplication(vehicleId, vehicleApplicationId);

  return investor.accountType === AccountType.Individual ? (
    <IndividualInvestor
      vehicleId={vehicleId}
      investor={investor}
      isActive={isActive}
      vehicleApplicationId={vehicleApplicationId}
      onSave={onSave}
    />
  ) : (
    <LegalEntity
      isActive={isActive}
      vehicleId={vehicleId}
      investor={investor}
      vehicleApplicationId={vehicleApplicationId}
      onSave={onSave}
    />
  );
};

export default CoreInformation;
